import { AbstractDTO } from "@signature-it/ngx-generic/models";

export class StockDTO extends AbstractDTO {
    stock: number;
    productCode: number;
    branchCode: number;
    branchQnty: number;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.productCode = attributes['product_code'] || -1;
        this.stock = attributes['stock'] ? parseInt(attributes['stock']) : 0;
        this.branchCode = attributes['branch_code'] ? parseInt(attributes['branch_code']) : 0;
        this.branchQnty = attributes['branch_qnty'] ? parseInt(attributes['branch_qnty']) : 0;
    }
}
